<div class="border-0 rounded-lg p-3 text-xs">

  <!-- ================= DESKTOP TABLE ================= -->
  <div class="custom-scroll-container table-responsive d-none d-md-block">
    <table :id="table_id" class="table table-hover dt-responsive">
      <thead class="custom-header">
        <tr>
          <th v-for="header in headers" :key="header" class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">
            {{ header }}
          </th>
          <th v-if="$slots.actions" class="text-uppercase text-xxs font-weight-bolder opacity-7">
            Action
          </th>
          <th v-if="$slots.assign" class="text-uppercase text-xxs font-weight-bolder opacity-7 ">
            Assign
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="(!Array.isArray(data) || data.length === 0) && !is_initializing">
          <td :colspan="headers.length + ($slots.actions ? 1 : 0) + ($slots.assign ? 1 : 0)" class="text-xxs text-muted">
            No matching records available
          </td>
        </tr>
        <template v-else>
          <tr v-for="(row, index) in data" :key="get_row_key(row, index)">
            <td v-for="(value, key) in row" :key="`${get_row_key(row, index)}-${key}`" class="text-xxs text-start">
              {{ value || value === 0 ? value : '-' }}
            </td>

            <td v-if="$slots.actions" class="text-start">
              <div class="d-flex gap-3">
                <slot name="actions" :row="row"></slot>
              </div>
            </td>
            <td v-if="$slots.assign" class="text-start">
              <div class="d-flex gap-3">
                <slot name="assign" :row="row"></slot>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>

  <!-- ================= MOBILE CARDS ================= -->
  <div class="d-md-none">
    <div class="row g-3">
      <div v-for="(row, index) in data" :key="get_row_key(row, index)" class="col-12">
        <div class="card shadow-sm border-0 rounded-lg p-3">

          <!-- DATA FIELDS -->
          <div v-for="(value, key) in row" :key="key" class="mb-1">
            <span class="fw-bold text-xxs text-dark">{{ key }} : </span>
            <span class="text-xxs">{{ value || value === 0 ? value : '-' }}</span>
          </div>

          <!-- ACTION BUTTONS -->
          <div class="d-flex justify-content-end gap-2 mt-3 flex-wrap">

            <template v-if="$slots.actions">
              <slot name="actions" :row="row"></slot>
            </template>

            <template v-if="$slots.assign">
              <slot name="assign" :row="row"></slot>
            </template>

          </div>
        </div>
      </div>

      <!-- EMPTY STATE -->
      <div v-if="(!data || data.length === 0) && !is_initializing" class="col-12 text-center">
        <p class="text-muted text-xxs">No matching records available</p>
      </div>
    </div>
  </div>
  
</div>
 